export const featureFlagsConfig = [
    'expert_services_intelligent_briefs',
    'design_services_holiday_hub',
    'design_services_sdp_inclusions',
    'design_services_hub_page_trust_signal',
    'collaboration_enable_file_downloads',
] as const;
